import type { MenuEntry } from "../DropdownMenu/DropdownMenu";

export interface SwitcherOrganization {
  id: string;
  name: string;
  /** Short text next to the name, e.g. the person's role there. */
  hint?: string;
}

export const COMBINED_TITLE = "All my organizations";

/** What the switcher needs to know about the current choice. */
export interface SwitcherChoice {
  organizations: SwitcherOrganization[];
  selectedId: string | null;
  combined: boolean;
}

/** The organization in view; the first one when none (or an unknown one) is selected. */
export function selectedOrganization({ organizations, selectedId }: SwitcherChoice): SwitcherOrganization | undefined {
  return organizations.find((o) => o.id === selectedId) ?? organizations[0];
}

export function switcherTitle(choice: SwitcherChoice): string {
  return choice.combined ? COMBINED_TITLE : (selectedOrganization(choice)?.name ?? "");
}

/** The combined view only makes sense with more than one organization. */
export function canCombine(organizations: SwitcherOrganization[]): boolean {
  return organizations.length > 1;
}

export function organizationMenuItems(choice: SwitcherChoice, onSelect: (organizationId: string) => void, onCombine: () => void): MenuEntry[] {
  const { organizations, combined } = choice;
  const selected = selectedOrganization(choice);
  const items: MenuEntry[] = [
    { heading: "Work in" },
    ...organizations.map((o) => ({
      label: o.name,
      hint: o.hint,
      selected: !combined && o.id === selected?.id,
      onSelect: () => onSelect(o.id),
    })),
  ];
  if (canCombine(organizations)) {
    items.push("separator", { label: "All my organizations together", icon: "layers", selected: combined, onSelect: onCombine });
  }
  return items;
}
